import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sketch': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M27.5 162.2l78.9-105.8-6.9 130.7h-90.5zM396.3 45.7l7.1 133.5-135.7-147.2zM112.2 218.3l122.6 239.7-224.9-261.7h91.1zM114.2 187.1l142.1-154.1 60.4 65.6 81.5 88.5h-284zM411.5 196.2v0.1h90.9l-224.8 261.7zM415.4 69l87.9 118.1h-90.3l-6.1-113.4-0.9-17.3zM113.5 93.5l2.6-47.8 128.6-13.7-135.8 147.1zM401.2 196.2l-144.9 283.8-102.7-200.9-42.4-82.9h290z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sketch.js
// module id = 1016
// module chunks = 0